import { combineReducers } from 'redux';

import account from './account';
import coinProducts from './coinProducts';
import deepLinks from './deepLinks';
import dismissableBanner from './dismissableBanner';
import env from './env';
import favorites from './favorites';
import fastpanel from './fastpanel';
import modals from './modals';
import nav from './nav';
import notifications from './notifications';
import packages from './packages';
import pagination from './pagination';
import search from './search';
import singleCard from './singleCard';
import tracking from './tracking';
import filters from './filters';
import route from './route';

// import cart from './cart';
// import eventDelivery from './eventDelivery';
// import event from './event';
// import experiments from './experiments';
// import forms from './forms';
// import tray from './tray';
// import viewport from './viewport';

// TODO: See if you can't get these into the types.js file without having to
// ignore all of the various flowtypes.  ++ if you can get esdoc to work with
// flow types
/**
 * @typedef {string} ActionType
 */

/**
 * @typedef {Object} Action
 * @property {ActionType} type
 * @property {Object|Array|string|number|boolean} [payload]
 */

/**
 * @typedef {function(arg: any): Action} ActionCreator
 */

export default combineReducers({
  account,
  coinProducts,
  deepLinks,
  dismissableBanner,
  env,
  favorites,
  fastpanel,
  modals,
  nav,
  notifications,
  packages,
  pagination,
  route,
  search,
  singleCard,
  tracking,
  filters,

  // cart,
  // eventDelivery,
  // event,
  // experiments,
  // forms,
  // tray,
  // viewport,
});
